import create from 'zustand'
import { persist } from 'zustand/middleware'

export const useShoppingListStore = create(
  persist(
    set => ({
      shoppingListItems: [],
      shoppingListCount: 0,
      shoppingListToggled: null,
      addItemFromInput: shoppingListItem => {
        set(state => ({
          shoppingListCount: state.shoppingListCount + 1,
          shoppingListItems: [
            ...state.shoppingListItems,
            {
              index: state.shoppingListCount,
              title: shoppingListItem.title,
              id: `${state.shoppingListItems.length}-${shoppingListItem.title}`,
              isBought: false,
              productGroup: shoppingListItem.productGroup,
              amount: shoppingListItem.amount || 1,
              input: true
            }
          ]
        }))
      },
      addItemFromProduct: (shoppingListItem, locale) => {
        let offerImage = null
        if (shoppingListItem.offerImage) {
          typeof shoppingListItem.offerImage !== 'string'
            ? (offerImage = `${shoppingListItem.offerImage?.image?.asset?.url}?w=71`)
            : (offerImage = `${shoppingListItem.offerImage}?w=71`)
        }

        const image =
          shoppingListItem.image &&
          shoppingListItem.image.replace('576x384', '300x200')

        set(state => ({
          shoppingListCount: state.shoppingListCount + 1,
          shoppingListItems: [
            ...state.shoppingListItems,
            {
              locale: locale,
              index: state.shoppingListCount,
              title: shoppingListItem.title,
              id: shoppingListItem.id || shoppingListItem._id,
              productId: shoppingListItem.itemno,
              isBought: false,
              offerImage: offerImage,
              image: image,
              amount: 1,
              brand: shoppingListItem.brand,
              productGroup:
                shoppingListItem.articleGroup?.productGroup.title ||
                shoppingListItem.productGroup?._ref ||
                'Sonstiges',
              shortdesc: shoppingListItem.shordesc,
              hasDiscount: shoppingListItem.shordesc?.includes('rabattiert'),
              subtitle: shoppingListItem.subtitle,
              price: shoppingListItem.price,
              validto: shoppingListItem.validto,
              isNeuImSortiment: shoppingListItem.isNeuImSortiment
            }
          ]
        }))
      },
      //for future usage: push ingredients to shoppinglist
      // addItemFromRecipe: shoppingListItem => {
      //   shoppingListItem.forEach(item => {
      //     // const image = item.image && item.image.replace('576x384', '300x200')
      //     set(state => ({
      //       shoppingListCount: state.shoppingListCount + 1,
      //       shoppingListItems: [
      //         ...state.shoppingListItems,
      //         {
      //           index: state.shoppingListCount,
      //           title: item.title,
      //           id: `${state.shoppingListItems.length}-${item.title}`,
      //           amount: 1,
      //           productGroup: item.category,
      //           recipe: item.recipe,
      //           isIngredient: true
      //         }
      //       ]
      //     }))
      //   })
      // },
      addItemAmount: shoppingListItem => {
        set(state => ({
          shoppingListItems: state.shoppingListItems.map(item =>
            item.id === shoppingListItem.id
              ? {
                  ...item,
                  amount: item.amount + 1
                }
              : item
          )
        }))
      },
      reduceItemAmount: shoppingListItem => {
        if (shoppingListItem.amount > 0) {
          set(state => ({
            shoppingListItems: state.shoppingListItems.map(item =>
              item.id === shoppingListItem.id
                ? {
                    ...item,
                    amount: item.amount - 1
                  }
                : item
            )
          }))
        }
      },
      deleteItem: shoppingListItemToDelete => {
          const id = shoppingListItemToDelete.id || shoppingListItemToDelete._id
          set(state => ({
            shoppingListItems: state.shoppingListItems.filter(
              shoppingListItem =>
                shoppingListItem.id !== id
            )
          }))
      },
      deleteItems: () => {
        set(() => ({
          shoppingListCount: 0,
          shoppingListItems: []
        }))
      },
      buyItem: shoppingListItemBought =>
        set(state => ({
          shoppingListItems: state.shoppingListItems.map(shoppingListItem => {
            if (shoppingListItem.id === shoppingListItemBought.id) {
              return {
                ...shoppingListItem,
                isBought: true
              }
            }
            return shoppingListItem
          })
        }))
    }),
    { name: 'shoppinglist-storage' }
  )
)
